import { User } from "../types";

export const getUserDisplayName = (user?: User | null): string => {
  if (!user) return "";

  return (
    user.Name ||
    user.Full_Name ||
    [user.First_Name, user.Last_Name].filter(Boolean).join(" ") ||
    ""
  );
};
